// Vendors
import styled from 'styled-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const ContractComponentStyled = styled.ul`
  display: flex;
  align-items: flex-start;
  gap: ${FoundationsCobrandedRegularTheme.spacing_300};
  align-self: stretch;
`;
ContractComponentStyled.displayName = 'ContractComponentStyled';

const ContractPDFViewerComponentStyled = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${convertPxsToRems({ pixels: 10, base: 16 })};
  align-self: stretch;
`;

ContractPDFViewerComponentStyled.displayName = 'ContractPDFViewerComponentStyled';

const ContractPDFViewerAreaStyled = styled.div`
  display: flex;
  padding: ${FoundationsCobrandedRegularTheme.spacing_250};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: ${convertPxsToRems({ pixels: 685, base: 16 })};
  gap: ${FoundationsCobrandedRegularTheme.spacing_200};
  flex: 1 0 0;
  border-radius: ${FoundationsCobrandedRegularTheme.radius_150};
  border: 1px solid ${FoundationsCobrandedRegularTheme.color_neutral_border_160};
`;

ContractPDFViewerAreaStyled.displayName = 'ContractPDFViewerAreaStyled';

const ConsentsContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  align-self: stretch;
`;

ConsentsContainerStyled.displayName = 'ConsentsContainerStyled';

const SelectIbanContainerStyled = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_200};
  width: 100%;
`;

SelectIbanContainerStyled.displayName = 'SelectIbanContainerStyled';

const FinancialDataGroupContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${convertPxsToRems({ pixels: 4, base: 16 })};
  align-self: stretch;
  word-break: break-word;
`;

FinancialDataGroupContainerStyled.displayName = 'FinancialDataGroupContainerStyled';

const FinancialDataWrapperStyled = styled.div`
  display: flex;
  padding: ${FoundationsCobrandedRegularTheme.spacing_200};
  flex-direction: column;
  align-items: flex-start;
  width: ${convertPxsToRems({ pixels: 447, base: 16 })};
  gap: ${FoundationsCobrandedRegularTheme.spacing_200};
  flex: 1 0 0;
  border-radius: ${FoundationsCobrandedRegularTheme.radius_150};
  border: 1px solid ${FoundationsCobrandedRegularTheme.color_neutral_border_160};

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    width: 100%;
  }
`;

FinancialDataWrapperStyled.displayName = 'FinancialDataWrapperStyled';

export {
  ContractComponentStyled,
  ContractPDFViewerComponentStyled,
  ContractPDFViewerAreaStyled,
  ConsentsContainerStyled,
  SelectIbanContainerStyled,
  FinancialDataWrapperStyled,
  FinancialDataGroupContainerStyled,
};
